/* eslint-disable @typescript-eslint/indent */
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  queryFilterSelector,
  SearchParams,
  searchStringState,
} from '~/src/FilterProjects/store';
import useApiClient from '~/src/hooks/useApiClient';
import { currentFolderState } from '~/src/ProjectFolder/store';
import { ENTRIES_PER_PAGE } from '../constants';
import {
  Entry,
  findError,
  pendingFind,
  projectListState,
  wereProjectsLoadedState,
} from '../store';

const useFind = () => {
  const apiClient = useApiClient();
  const setFindPending = useSetRecoilState(pendingFind);
  const setResults = useSetRecoilState(projectListState);
  const setFindError = useSetRecoilState(findError);
  const setProjectsLoaded = useSetRecoilState(wereProjectsLoadedState);
  const currentFolder = useRecoilValue(currentFolderState);
  const filters = useRecoilValue(queryFilterSelector);
  const searchString = useRecoilValue(searchStringState);

  const find = async () => {
    try {
      setFindError(null);
      setFindPending(true);

      const params: SearchParams = {
        limit: ENTRIES_PER_PAGE,
        skip: 0,
      };

      let requestFilters;

      switch (true) {
        case !!filters && !currentFolder:
          requestFilters = filters;
          break;
        case !filters && !!currentFolder:
          requestFilters = { folderId: currentFolder?._id };
          break;
        case !!filters && !!currentFolder:
          requestFilters = {
            folderId: currentFolder?._id,
            ...(filters || {}),
          };
          break;
        default:
          requestFilters = {};
      }

      params.filter = btoa(JSON.stringify(requestFilters));

      if (searchString?.value) {
        params.query = searchString?.value;
      }

      const {
        data: { data, pagination },
      } = await apiClient.get<{
        data: Entry[];
        pagination: {
          hasMore: boolean;
        };
      }>('/search', { params });
      setResults({
        entries: data,
        hasMore: pagination?.hasMore || false,
      });
      setProjectsLoaded(true);
      return data;
    } catch (err) {
      setFindError(err);
      throw err;
    } finally {
      setFindPending(false);
    }
  };

  return [find];
};

export default useFind;
